import { render } from "./bottom-options.vue?vue&type=template&id=c0b4ad74"
import script from "./bottom-options.vue?vue&type=script&lang=js"
export * from "./bottom-options.vue?vue&type=script&lang=js"

import "./bottom-options.vue?vue&type=style&index=0&id=c0b4ad74&lang=postcss"
script.render = render

export default script